import React from 'react';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let TableRowItalic = React.createClass({

    overLimit: function () {
        this.props.aparicionLapizEdicion(this.props.row.Id);
    },

    viewEdit: function () {
        if (this !== null) {
            this.props.muestraEditadoNovedad(this.props.row.Id);
        }
        else {
            viewEditNoRow();
        }
    },

    viewEditClose: function () {
        this.props.ocultaEditadoNovedad();
    },

    render: function () {
        let drawName = null;
        let drawNovedad = null;
        let timeToNovedad = null;
        let fecha = null;
        let hora = null;
        let name = this.props.row.Descripcion;
        let valorNovedad;
        let valor;
        let limiteCompra = this.props.data.limiteCompra;

        if (this.props.novedad !== undefined) {
            
            valorNovedad = this.props.novedad.ValorNovedad;
            let valorAnterior = this.props.novedad.ValorAnterior;

            if (this.props.novedadEditado != undefined) {
                if (this.props.novedadEditado.edited) {
                    valor = this.props.novedadEditado.ValorNovedad;
                }
                else {
                    valor = valorNovedad;
                }
            } else {
                valor = valorNovedad;
            }

            let valorLimiteCompra = limiteCompra.find(x => x.Id == valor).Valor;
            valor = GlobalHelper.ConvertirNumeroMilesMillones(valorLimiteCompra);

            timeToNovedad = this.props.novedad.FechaHoraModificacion.replace("T", " ").replace("Z", "");
            fecha = timeToNovedad.substring(0, 10).split("-");
            hora = timeToNovedad.substring(16, 11);

            drawName = <div className="col-md-4">
                <label className="label-secondary">{name}</label>
            </div>

            if (this.props.editadoRow == true) {
                let valorAnteriorLimiteCompra = limiteCompra.find(x => x.Id == valorAnterior).Valor;
                valorAnterior = GlobalHelper.ConvertirNumeroMilesMillones(valorAnteriorLimiteCompra);

                drawNovedad = <div className="row">
                    <div className="col-md-6">
                    </div>
                    <div className="col-md-6">
                        <p><sub><i>Editado el {fecha[2] + "-" + fecha[1]} a las {hora} por {this.props.novedad.UsuarioLoginModificacion}. Era ${valorAnterior}.</i></sub><a className="clickable" onClick={this.viewEditClose}><sub><ins><i>Cerrar</i></ins></sub></a></p>
                    </div>
                </div>
            }
            else {
                drawNovedad = <div className="row">
                    <div className="col-md-6">
                    </div>
                    <div className="col-md-6">
                        <a className="clickable" onClick={this.viewEdit}><sub><ins><i>Editado</i></ins></sub></a>
                    </div>
                </div>
            }

        } else {
            name = name + " :"

            drawName = <div className="col-md-4">
                <label className="label-secondary"><i>{name}</i></label>
            </div>
        }

        return (
            <div className="row">
                <div className="col-md-2">
                </div>
                {drawName}
                <div className="col-md-6" onMouseOver={this.overLimit}>
                    <label className="label-secondary"><i>$</i></label>
                    <label className="label-secondary color-azul-claro"><i>{valor}</i></label>
                </div>
                {drawNovedad}
            </div>
        );
    }
});

export default TableRowItalic